export default __webpack_public_path__ + "static/profile-0f188bb515ddde9d00d4c4789db960ad.jpg";